import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0% {opacity: .2;}
  20% {opacity: 1;}
  100% {opacity: .2;}
`;

export const LoadingText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #555;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 16px 0;

  span {
    animation: ${blink} 1.4s infinite both;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
